import { GroupImageEdit } from './GroupImageEdit'

export default {
  list: null,
  edit: GroupImageEdit,
}
